export function getSimpleNumber(number, decimalPoints = 2, convertToNumber = true) {
  if (String(number).includes('.')) {
    const fixedNum = number.toFixed(decimalPoints);
    return convertToNumber ? Number(fixedNum) : fixedNum;
  }

  return number;
}
